import { render } from "./NotificationsMenu.vue?vue&type=template&id=6ec1fa5c&scoped=true"
import script from "./NotificationsMenu.vue?vue&type=script&lang=js"
export * from "./NotificationsMenu.vue?vue&type=script&lang=js"

import "./NotificationsMenu.vue?vue&type=style&index=0&id=6ec1fa5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ec1fa5c"]])

export default __exports__